import { productsURL } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect } from 'react';
import { LoadingAction } from 'store/actions';
import { processIdSelector } from 'store/selectors';
import { LoadingState } from 'store/state';
import useSWR from 'swr';
import type { Products } from 'types';

export function useCreditCheck() {
	const ctx = useContext(AppContext);
	const processId = processIdSelector(ctx.state.context);
	const { config, dispatch, goToNextPage, t } = ctx;
	const { API } = config;
	const { data, isLoading } = useSWR<Products>(productsURL(API, processId, false));
	const message = t('loading_text', 'products');

	useEffect(() => {
		data?.hasInternalCreditCheck && goToNextPage();
	}, [data]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const msg = isLoading ? message : '';
		dispatch([LoadingAction, { loading: LoadingState(0, msg) }]);
	}, [isLoading, message]); // eslint-disable-line react-hooks/exhaustive-deps

	return { ...ctx, data };
}
